export function isAuthorizationQueryAuthFailure(error) {
    if (!error) return false
    if (error.status === 401) return true
    if (error.networkError?.status === 401) return true
    if (error.networkError?.statusCode === 401) return true
    if (error.graphQLErrors?.some(isUnauthorizedGraphQLError)) return true
    return String(error.message ?? "").includes("Unauthorized")
}

export function getAuthorizationQueryFallback(previousAuthorization) {
    if (Array.isArray(previousAuthorization)) return previousAuthorization
    return [null, null]
}

function isUnauthorizedGraphQLError(error) {
    return error?.extensions?.code === "UNAUTHENTICATED" || String(error?.message ?? "").includes("Unauthorized")
}
